import { InvoicePayable } from '../components/interface';
import { useCallback, useEffect, useState } from 'react';
import { useNotification } from '@refinedev/core';
import { httpClient, ROOT_URL } from '../../App';
import { getErrorMessage } from '../../api/error';

export const useInvoicePayable = (id?: number) => {
  const [data, setData] = useState<InvoicePayable>();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>();

  const { open: openNotification } = useNotification();

  const fetch = useCallback(async () => {
    setError(undefined);
    if (id) {
      try {
        setIsLoading(true);
        const result = await httpClient.get(`${ROOT_URL}/api/v1/invoice_payables/${id}`);

        if (result.status === 200) {
          setData(result.data);
        }
      } catch (error) {
        setError(getErrorMessage(error));
        setData(undefined);
      } finally {
        setIsLoading(false);
      }
    }
  }, [id]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  useEffect(() => {
    if (error) {
      openNotification?.({
        key: 'edit_failure',
        message: `Error loading invoice #${id}`,
        description: error || 'Something went wrong',
        type: 'error',
      });
    }
  }, [error, fetch, id, openNotification]);

  const clearData = useCallback(() => {
    setData(undefined);
  }, []);

  return {
    data,
    fetch,
    isLoading,
    clearData,
  };
};
